// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"c7bca199","209":"1875731c","240":"731f2025","343":"180f10fd","349":"19e1b6df","392":"0c832fe5","427":"7e0db9b4","453":"f29b55bf","495":"c6a4e0fb","589":"178527b7","881":"894d3f67"}[chunkId] + ".chunk.js";
};